import React, { useEffect, useState } from 'react';
import ModalShell from './ModalShell';
import { deleteCategoryApi, getCategoryUsage } from '../../lib/api';

export default function DeleteCategoryModal({ colors, category, allCategories, onClose, onDone }) {
  const [usage, setUsage] = useState(null);
  const [choice, setChoice] = useState('uncategorized');
  const [reassignId, setReassignId] = useState('');
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    getCategoryUsage(category.id).then(setUsage).catch(() => setUsage({ count: 0 }));
  }, [category.id]);

  const submit = async () => {
    setDeleting(true); setError(null);
    try {
      const r = await deleteCategoryApi(
        category.id,
        choice === 'reassign' ? reassignId : undefined,
      );
      onDone(r.reassigned_count);
    } catch (e) { setError(e?.detail || 'Delete failed'); } finally { setDeleting(false); }
  };

  const others = allCategories.filter((c) => c.id !== category.id && !c.is_special);

  return (
    <ModalShell colors={colors} onClose={onClose} title={`Delete "${category.name}"?`} testId="mc-delete-modal">
      {usage === null ? (
        <p className="text-sm" style={{ color: colors.textMuted }}>Loading usage…</p>
      ) : usage.count === 0 ? (
        <p className="text-sm" style={{ color: colors.textMuted }}>Not used by any receipts.</p>
      ) : (
        <>
          <p className="text-sm" style={{ color: colors.textMuted }}>
            Used by <strong style={{ color: colors.text }}>{usage.count}</strong> receipt{usage.count === 1 ? '' : 's'}. What should happen to them?
          </p>
          <label data-testid="mc-choice-uncat" className="flex items-center gap-2 mt-3 cursor-pointer p-2 rounded-lg"
            style={{ backgroundColor: choice === 'uncategorized' ? colors.accentSoft : 'transparent' }}
          >
            <input type="radio" checked={choice === 'uncategorized'} onChange={() => setChoice('uncategorized')} />
            <span className="text-sm" style={{ color: colors.text }}>Set them to Uncategorized</span>
          </label>
          <label data-testid="mc-choice-reassign" className="flex items-center gap-2 cursor-pointer p-2 rounded-lg"
            style={{ backgroundColor: choice === 'reassign' ? colors.accentSoft : 'transparent' }}
          >
            <input type="radio" checked={choice === 'reassign'} onChange={() => setChoice('reassign')} />
            <span className="text-sm" style={{ color: colors.text }}>Move to another category</span>
          </label>
          {choice === 'reassign' ? (
            <select
              data-testid="mc-reassign-select"
              value={reassignId}
              onChange={(e) => setReassignId(e.target.value)}
              className="w-full mt-2 px-3 py-2 rounded-lg text-sm outline-none"
              style={{ backgroundColor: colors.bg, color: colors.text, border: `1px solid ${colors.border}` }}
            >
              <option value="">— pick one —</option>
              {others.map((c) => (
                <option key={c.id} value={c.id}>{c.name} ({c.group})</option>
              ))}
            </select>
          ) : null}
        </>
      )}
      {error ? <p className="text-xs mt-2" style={{ color: colors.error }}>{error}</p> : null}
      <div className="mt-3 flex gap-2">
        <button onClick={onClose} className="flex-1 py-2 rounded-lg text-sm font-semibold border"
          style={{ backgroundColor: colors.surface, borderColor: colors.border, color: colors.textMuted }}
        >Cancel</button>
        <button
          data-testid="mc-delete-confirm"
          onClick={submit}
          disabled={deleting || (choice === 'reassign' && !reassignId)}
          className="flex-1 py-2 rounded-lg text-sm font-semibold text-white"
          style={{ backgroundColor: colors.error, opacity: (deleting || (choice === 'reassign' && !reassignId)) ? 0.5 : 1 }}
        >{deleting ? '…' : 'Delete'}</button>
      </div>
    </ModalShell>
  );
}
